import React, {useEffect, useState} from "react";
import {navButtons, quizSubtitle} from "../../constants/copyright";
import Button from "../baseComponents/gui/button/Button";
import classNames from "classnames";
import {usePanel} from "../../redux/reducer/panel";
import {safeHTML} from "../../utils/safeHTML";
import Recommendations from "../recommendations/Recommendations";
import Tag from "../baseComponents/gui/tag/Tag";
import QuizStart from "./QuizStart";
import QuizItem from "./QuizItem";
import {CSSTransition, SwitchTransition} from "react-transition-group";
import QuizResult from "./QuizResult";
import numWord from "../../utils/numWord";
import styles from "./Quiz.module.scss";


const Quiz = React.forwardRef(
  function Quiz(props, ref) {
    const {
      title, tags, content,
      preview, recommendation
    } = props;
    const {start_text, quizQuestions, quizResults} = content;
    const {buttonBack, buttonToTop} = navButtons;
    const subtitle = quizSubtitle;
    const {filter} = usePanel();
    const [quizState, setQuizState] = useState("start");
    const [activeItem, setActiveItem] = useState(0);
    const [score, setScore] = useState(0);


    useEffect(() => {
      if (quizState === "start"){
        setActiveItem(0);
        setScore(0);
      }
    }, [quizState]);


    const quizContent = {
      start: () => (
        <QuizStart description={start_text}
                   preview={preview}
                   onClick={() => setQuizState("quiz")}
        />
      ),
      quiz: () => (
        <QuizItem
          {...quizQuestions[activeItem]}
          length={quizQuestions.length}
          activeItem={activeItem}
          next={(a) => {
            setScore(score + a);
            if (activeItem + 1 < quizQuestions.length) {
              setActiveItem(activeItem + 1)
            } else {
              setQuizState("result")
            }
          }}
        />
      ),
      result: () => (
        <QuizResult
          content={quizResults}
          score={score}
          repeat={() => setQuizState("start")}
        />
      ),
      default: () => (
        <></>
      )
    };


    return (
      <section className={styles.quiz} ref={ref}>
        <div className={styles.quiz__content}>
          <Button {...buttonBack} routerUrl={filter === '/' ? filter : '/' + filter}
                  className={classNames("news__back", buttonBack.className)}/>
          <div className={styles.quiz__header}>
            <div className={styles.quiz__subtitle}>{safeHTML(subtitle)}</div>
            <h1 className={styles.quiz__title}>{safeHTML(title)}</h1>
            <div className={styles.quiz__tags}>
              <div className="tag">
                <div className="tag__name">
                  {`${quizQuestions.length} ${numWord(quizQuestions.length, ["вопрос","вопроса","вопросов"])}`}
                </div>
              </div>
              {tags?.map((el, id) => <Tag key={`tag-${id}`} {...el}/>)}
            </div>
          </div>

          <SwitchTransition>
            <CSSTransition key={`${quizState}-${activeItem}`}
                           timeout={500}
                           classNames={{
                             enter: styles.quizSectionEnter,
                             enterActive: styles.quizSectionEnterActive,
                             enterDone: styles.quizSectionEnterDone,
                             exit: styles.quizSectionExit,
                             exitActive: styles.quizSectionExitActive,
                             exitDone: styles.quizSectionExitDone
                           }}
            >
              {(quizContent[quizState] || quizContent.default)()}
            </CSSTransition>
          </SwitchTransition>


          <Recommendations title={"Рекомендуем"} list={recommendation} mod={"quiz"} showAnimation={true}/>
          <Button {...buttonToTop} onClick={() => scrollTo({top: 0, behavior: "smooth"})}
          />
        </div>
      </section>
    );
  });
export default Quiz;
Quiz.propTypes = {};

